import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AdminAuthService } from '../services/admin-auth.service';
import { PortalAuthService } from '../services/portal-auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const adminAuth = inject(AdminAuthService);
  const portalAuth = inject(PortalAuthService);

  // Choose token based on URL
  let token: string | null = null;
  if (req.url.includes('/admin/')) {
    token = adminAuth.getToken();
  } else if (req.url.includes('/portal/')) {
    token = portalAuth.getToken();
  }

  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(req);
};
